// s31-pubkey_contact
import selfHtml from './s31-pubkey_contact.html' with { type: 'text' };;

import { mod_loader, MsgComposeModule, KeyDetailsModule } from "../AppState.js";

import { add_pub_key, get_pub_key } from "../crypt_helper.js";

var root

export async function init(module_root, pubk_armoured) {

    module_root.innerHTML = selfHtml;

    root = module_root

    const pubkey = pubk_armoured;

    root.querySelector(".btn_discard_key").addEventListener('click', () => window.location = './');

    root.querySelector(".btn_add_contact_key").addEventListener('click', async () => add_key(await get_pub_key(pubkey)));

    await mod_loader(KeyDetailsModule, { target: ".div_key_details", 'key': await get_pub_key(pubkey) })

}

async function add_key(key) {

    const obj_pubkey = await add_pub_key(key.myKeyPairPublicKey);

    document.global_last_pubkey_seen = obj_pubkey;

    mod_loader(MsgComposeModule, key);

}
